// extracted by mini-css-extract-plugin
module.exports = {"sellPointsModule":"First_sellPointsModule__zhgVh"};